function hotels(state = [], action) {
    switch (action.type) {
        case 'HOTEL/SET':
            return action.hotel;
        case 'HOTEL/CLEAR':
            return null;
        default:
            return state;
    }
}

export default hotels;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/hotel.js